module.exports = __webpack_public_path__ + "img/pick4.46d84063.png";